import PropTypes from 'prop-types'
import React from 'react'
import loadable from '@loadable/component'

import { imageUrl } from '../../ThemeView'
import LazyImage from '../../LazyImage'

export const ZoomableImage = loadable(() => import(/* webpackChunkName: "Product" */ '../../ZoomableImage'))

export default function ProductImage({ image, alt }) {
  return (
    <>
      {image.isZoomEnabled ? (
        <ZoomableImage src={image.url} width={image.width} height={image.height} alt={alt} />
      ) : (
        <LazyImage
          src={image.url}
          alt={alt}
          originalWidth={image.width}
          style={{ maxWidth: image.width }}
          noscript={false}
        />
      )}
      <noscript>
        <img src={imageUrl(image.url, 600, 2560)} alt={alt} style={{ maxWidth: image.width }} itemProp="image" />
      </noscript>
    </>
  )
}

ProductImage.propTypes = {
  alt: PropTypes.string.isRequired,
  image: PropTypes.shape({
    isZoomEnabled: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
}
